<template>
  <div class="">
    <BusinessBody />
  </div>
</template>
<script>
import BusinessBody from "./components/BusinessBody.vue";
export default {
  components: {
    BusinessBody,
  },
};
</script>
